import React, { FocusEvent, useEffect, useRef, useState } from "react";
import Autocomplete, {
    createFilterOptions,
} from "@material-ui/lab/Autocomplete";
import { TextField } from "@material-ui/core";
import { FormikProps } from "formik";
// import  { Container } from './styles';

interface AutoCompleteProps {
    onBlur: (e: FocusEvent<HTMLInputElement>) => void;
    onChange: (e: any, value: any) => void;
    inputChange: (value: string) => void;
    getOptionSelected: (option: any, value: any) => boolean;
    getOptionLabel: (option: any) => string;
    value: string;
    label: string;
    name?: string;
    error?: any;
    options?: any[];
    helperText?: string;
    selectedValue?: any;
    disabled?: boolean;
}
const AutoCompleteComponent: React.FC<AutoCompleteProps> = ({
    onBlur,
    inputChange,
    onChange,
    getOptionLabel,
    getOptionSelected,
    value,
    error,
    name,
    options,
    selectedValue,
    label,
    helperText,
    disabled = false,
}) => {
    const [openAutoComplete, setOpenAutoComplete] = useState(false);


    useEffect(() => {
        const handleClick = (event) => {
            const element = event.target as any
            if (element.id.includes("generic-auto-complete")) {
                setOpenAutoComplete(false)
            }
        }
        document.addEventListener("click", handleClick)
        // Remove o listener ao desmontar
        return () => {
            document.removeEventListener("click", handleClick);
        };

    }, [])

    return (
        <Autocomplete
            id="generic-auto-complete"
            disabled={disabled}
            fullWidth
            openOnFocus={false}
            value={selectedValue}
            // Para não abrir as opções ao clicar no input
            onInputChange={(event, newInputValue) => {
                inputChange(newInputValue);
                if (newInputValue.length > 2) {
                    setOpenAutoComplete(true);
                } else {
                    setOpenAutoComplete(false);
                }
            }}
            open={openAutoComplete}
            filterOptions={createFilterOptions({
                matchFrom: "any",
                ignoreCase: true,
                limit: 3,
                ignoreAccents: true,
            })}
            options={options}
            getOptionSelected={getOptionSelected}
            getOptionLabel={getOptionLabel}
            onChange={onChange}
            inputValue={value}
            clearOnBlur={false}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={label}
                    onBlur={onBlur}
                    value={value || ""}
                    name={name}
                    helperText={helperText}
                    error={error}
                />
            )}
        />
    );
};

export default AutoCompleteComponent;
